import React, { useRef, useEffect,useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import { CircleLoader } from "react-spinners";
import { useQuery } from "@tanstack/react-query";
import moment from 'moment'
import { fetchEvents } from "../utils/api";

// CountdownTimer component (unchanged)
function CountdownTimer({ date, time }) {
  const [timeLeft, setTimeLeft] = React.useState("");

  React.useEffect(() => {
    if (!date || !time) {
      setTimeLeft("Invalid Date");
      return;
    }
    const targetDateTime = new Date(`${date}T${time}:00`);
    const interval = setInterval(() => {
      const now = new Date();
      const diff = targetDateTime - now;
      if (diff <= 0) {
        setTimeLeft("Event started!");
        clearInterval(interval);
      } else {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [date, time]);

  return (
    <p className="text-xs text-green-600 font-semibold mb-4">
      Starts in: {timeLeft}
    </p>
  );
}

// Main component
export default function HomeEvents() {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState("All");
  const [filters, setFilters] = useState({
    name: "",
    location: "",
    startDate: "",
    mode: "",
  });


  const token = localStorage.getItem("Startuptoken");

const getEventDateTime = (event) => {
  try {
    const timePart = event.time ? event.time : "00:00";
    return new Date(`${event.date}T${timePart}:00`);
  } catch {
    return new Date(event.date || 0);
  }
};

const computeStatusForEvent = (event) => {
  const eventDT = getEventDateTime(event);
  if (isNaN(eventDT.getTime())) return event.status || "Upcoming";
  return eventDT.getTime() < Date.now()
    ? "Completed"
    : (event.status || "Upcoming");
};
 

  const startupToken = localStorage.getItem("Startuptoken");
  const isLoggedIn = Boolean(startupToken && startupToken !== "DEMO_TOKEN");

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["events", filters, activeTab, isLoggedIn],
    queryFn: () =>
      fetchEvents({
        ...filters,
        activeTab,
        limit: 7
      }),

    // 🔥 CACHE CONTROL
    staleTime: 0,                // data becomes stale immediately
    gcTime: 1000 * 60 * 10,        // cache kept for 2 minutes (v5)
    refetchOnWindowFocus: false,  // no auto refetch on tab switch
    refetchOnReconnect: false,    // no refetch on network reconnect
    retry: false,                // no retry spam
  });


  const {
    selectedDateEvents = [],
    upcomingEvents = [],
    hasDateFilter = false
  } = data || {};

const normalizedUpcomingEvents = React.useMemo(
  () =>
    upcomingEvents.map(event => ({
      ...event,
      status: computeStatusForEvent(event),
    })),
  [upcomingEvents]
);


  const normalizeModes = (event) => {
    if (Array.isArray(event?.eventMode)) return event.eventMode;
    if (typeof event?.eventMode === "string") return [event.eventMode];
    return [];
  };

  const filterByEventMode = (events = []) => {
    return events.filter(event => {
      // ✅ Always show completed events
      if (event.status === "Completed") {
        return true;
      }

      const modes = normalizeModes(event);

      if (isLoggedIn) {
        return modes.includes("Registered");
      }

      return modes.includes("NonRegistered");
    });
  };



  const finalUpcomingEvents = filterByEventMode(normalizedUpcomingEvents);


  useEffect(() => {
    console.log(finalUpcomingEvents)
  }, [finalUpcomingEvents])



  // Prepare current events
  const currentEvents = finalUpcomingEvents;


  React.useEffect(() => {
    console.log("current event", currentEvents)
  }, [currentEvents])

  // Slider controls
  const scrollNext = () => {
    if (sliderRef.current) {
      const cardWidth = window.innerWidth > 640 ? 360 : window.innerWidth - 32;
      sliderRef.current.scrollBy({
        left: cardWidth,
        behavior: "smooth",
      });
    }
  };
  const scrollPrev = () => {
    if (sliderRef.current) {
      const cardWidth = window.innerWidth > 640 ? 360 : window.innerWidth - 32;
      sliderRef.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
    }
  };

  // Truncate helper
  const truncateWords = (text, maxLength = 25) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trimEnd() + "...";
  };

  const renderSlider = (title, list) => (
    <div className="rounded-lg p-4 sm:p-6">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{title}</h2>
        <button
          onClick={() => navigate("/events")}
          className="text-sm font-medium text-[#fd3e3d] hover:underline"
        >
          View All
        </button>
      </div>
      <p className="text-xs sm:text-sm text-gray-600 mb-4">
        Discover, join, and experience the best events around you!
      </p>
      <div className="relative">
        <div
          ref={sliderRef}
          className="flex gap-4 overflow-x-auto pb-4 scroll-smooth hide-scrollbar"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <style>
            {`
              .hide-scrollbar::-webkit-scrollbar {
                display: none;
              }
              .ticket-card {
                width: calc(90vw - 2rem);
              }
              @media (min-width: 640px) {
                .ticket-card {
                  width: 350px;
                }
              }
            `}
          </style>
        {list.map((event, i) => (
  <motion.div
    key={event._id}
    className="
      ticket-card relative
      bg-white border border-gray-200 rounded-2xl overflow-hidden
      flex-shrink-0
      min-h-[160px] sm:min-h-[200px]
    "
    initial={{ opacity: 0, x: 20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.3, delay: i * 0.1 }}
  >
    {/* LEFT notch */}
    <div
      className="
        before:content-[''] before:absolute
        before:left-[-12px]
        before:top-[110px] sm:before:top-[132px]
        before:-translate-y-1/2
        before:w-5 before:h-3
        before:bg-[#f8f6f5]
        before:rounded-r-full before:border
      "
    />

    {/* RIGHT notch */}
    <div
      className="
        after:content-[''] after:absolute
        after:right-[-12px]
        after:top-[110px] sm:after:top-[132px]
        after:-translate-y-1/2
        after:w-5 after:h-3
        after:bg-[#f8f6f5]
        after:rounded-l-full after:border
      "
    />

    {/* Dashed line */}
    <div
      className="
        absolute left-[12px] right-[12px]
        top-[98px] sm:top-[136px]
        border-t border-dashed border-gray-300
        pointer-events-none
      "
    />

    {/* STATUS BADGE */}
    {(event.isNewLaunch || ["Ongoing", "Completed"].includes(event.status)) && (
      <div className="absolute top-0 left-0 z-10 mt-1 ml-1">
        <span
          className={`text-[10px] sm:text-xs font-bold px-2 py-1 rounded-br-lg ${
            event.isNewLaunch
              ? "bg-green-200 text-green-800"
              : event.status === "Ongoing"
              ? "bg-yellow-200 text-yellow-800"
              : "bg-gray-300 text-gray-800"
          }`}
        >
          {event.isNewLaunch
            ? "New"
            : event.status === "Ongoing"
            ? "Ongoing"
            : "Completed"}
        </span>
      </div>
    )}

    {/* ENTRY FEE BADGE */}
    <div className="absolute top-0 right-0 z-10 mt-1">
      <span className="bg-[#fd3e3d] text-white text-[10px] sm:text-xs font-semibold px-3 py-1 rounded-tl-lg rounded-br-lg">
        {event.type[0] === "Paid"
          ? `ENTRY FEE ₹${event.amount}/-`
          : "FREE EVENT"}
      </span>
    </div>

    {/* CONTENT */}
    <div className="p-3 pt-8 pb-2 sm:p-4 sm:pt-10 sm:pb-3">
      <div className="flex items-start gap-3 sm:gap-4">
        {/* LOGO */}
        <div className="relative w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 flex-shrink-0">
          {event.logo ? (
            <img
              src={event.logo}
              alt={event.name}
              className="w-full h-full object-cover rounded"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center rounded">
              <Sparkles className="w-5 h-5 sm:w-7 sm:h-7 text-white" />
            </div>
          )}
        </div>

        {/* TEXT */}
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-gray-900 text-sm sm:text-base lg:text-lg leading-tight">
            {truncateWords(event.name, 20)}
          </h3>

          <p className="text-[11px] sm:text-xs text-gray-600">
            Hosted by {event.title || "Organizer Name"}
          </p>

          <p className="text-[11px] sm:text-xs text-gray-600">
            {moment(`${event.date} ${event.time}`, "YYYY-MM-DD HH:mm").format(
              "DD-MM-YYYY | h:mm A"
            )}
          </p>
        </div>
      </div>

      {/* BOTTOM SECTION */}
      <div className="mt-3 sm:mt-5 flex items-center justify-between px-1 pt-4 sm:pt-6 pb-1 gap-2 sm:gap-6">
        <div>
          <p className="text-[11px] sm:text-xs font-semibold">
            {event.mode || "Online"}
          </p>
          <p className="text-[11px] sm:text-xs text-gray-600">
            {event.location || event.address}
          </p>
        </div>

        <button
          onClick={() => navigate(`/event-description/${event._id}`)}
          className="
            inline-flex items-center gap-1
            bg-[#020c1b] hover:bg-[#0d1a2e]
            text-white
            text-[10px] sm:text-xs
            font-semibold
            py-1.5 px-3
            rounded-full
            transition duration-200
          "
        >
          View More
          <ChevronRight className="text-[#fd3e3d] w-3 h-3 sm:w-4 sm:h-4" />
        </button>
      </div>
    </div>
  </motion.div>
))}

        </div>
        {list.length > 1 && (
          <>
            <button
              onClick={scrollPrev}
              className="hidden sm:block absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white border border-gray-300 rounded-full p-2 shadow-md hover:shadow-lg transition-shadow"
            >
              <ChevronLeft className="w-4 h-4 text-gray-600" />
            </button>
            <button
              onClick={scrollNext}
              className="hidden sm:block absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white border border-gray-300 rounded-full p-2 shadow-md hover:shadow-lg transition-shadow"
            >
              <ChevronRight className="w-4 h-4 text-gray-600" />
            </button>
          </>
        )}
      </div>
    </div>
  );

 

  if (isLoading) {
    if (currentEvents.length === 0) {
      return null;
    }
    return (
      <div className="container mx-auto px-4 sm:px-6 py-8">
        <div className="flex justify-center items-center py-12">
          <CircleLoader size={40} />
          <span className="ml-2 text-gray-600">Loading events...</span>
        </div>
      </div>
    );
  }

  if (!isLoading && currentEvents.length === 0) {
    return null;
  }

  return (
    <div className="container mx-auto px-4 sm:px-6 py-8">
      {renderSlider("Upcoming Events", currentEvents)}
    </div>
  );
}
